module.exports = __webpack_public_path__ + "img/logout-icon.c6c576b4.svg";